import { BetTypes } from "../../../../types";
import { getOccurrenceProps, getMarketResultProps, getEventNameRaceProps, getRuleDeductionProps } from "../../selection";
import { getDictPhrase } from "../../../common";
export const getEventDetailsRaceProps = (betType, selection, state) => {
    return {
        eventName: getEventNameRaceProps(selection, state),
        occurrence: getOccurrenceProps(selection.startEventDate, state, getDictPhrase(state.dict, "Starts")),
        marketResult: betType !== BetTypes.YourBet ? getMarketResultProps(selection, state) : undefined,
        ruleDeduction: selection.rule4Deduction ? getRuleDeductionProps(selection) : undefined
    };
};
//# sourceMappingURL=getEventDetailsRaceProps.js.map